import { FeatureFlags, useFeatureFlag } from '@/modules/featureFlags';

const useNewFileSearchFeatureFlag = () => {
  const isAvailable = useFeatureFlag(FeatureFlags.NEW_FILE_SEARCH);

  return isAvailable;
};

export default useNewFileSearchFeatureFlag;
